if (!customElements.get('linked-products-size-picker')) {
  class LinkedProductsSizePicker extends HTMLElement {
    static splitSkuReference(skuReference) {
      const normalizedReference = `${skuReference || ''}`.trim();
      const match = normalizedReference.match(/^(.+)[._/\-]([^._/\-]+)$/);

      if (!match) {
        return { root: '', size: '' };
      }

      return {
        root: (match[1] || '').trim(),
        size: (match[2] || '').trim(),
      };
    }

    static compareSizes(firstEntry, secondEntry) {
      if (firstEntry.sizeNumber === null && secondEntry.sizeNumber === null) return 0;
      if (firstEntry.sizeNumber === null) return 1;
      if (secondEntry.sizeNumber === null) return -1;

      return firstEntry.sizeNumber - secondEntry.sizeNumber;
    }

    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.initializeItems();
    }

    initializeItems() {
      const items = Array.from(this.querySelectorAll('[data-linked-product-item]'));
      const list = this.querySelector('[data-linked-products-list]');

      if (!items.length || !list) return;

      const currentItem = items.find((item) => item.dataset.current === 'true') || items[0];
      const currentReference = LinkedProductsSizePicker.splitSkuReference(currentItem.dataset.sku);
      const currentLabel = this.querySelector('[data-linked-products-current]');

      if (currentLabel) currentLabel.textContent = currentReference.size || '—';

      const entries = items.map((item) => {
        const reference = LinkedProductsSizePicker.splitSkuReference(item.dataset.sku);
        const sizeNumber = Number.parseFloat(reference.size.replace(',', '.'));

        return {
          item,
          reference,
          sizeNumber: Number.isFinite(sizeNumber) ? sizeNumber : null,
        };
      });

      entries.forEach((entry) => {
        const hasDifferentRoot =
          currentReference.root && entry.reference.root && currentReference.root !== entry.reference.root;

        if (!entry.reference.size || hasDifferentRoot) {
          entry.item.classList.add('is-disabled');
          entry.item.removeAttribute('href');
          entry.item.setAttribute('aria-disabled', 'true');
          entry.item.setAttribute('tabindex', '-1');
          return;
        }

        entry.item.textContent = entry.reference.size;
      });

      entries.sort(LinkedProductsSizePicker.compareSizes).forEach((entry) => list.appendChild(entry.item));
    }
  }

  customElements.define('linked-products-size-picker', LinkedProductsSizePicker);
}
